import React from "react"
import { 
    BoxFilterableCol, 
    BreakLine, 
    Container, 
    Th, 
    THead, 
    ThFilterable, 
    Tr 
} from "./style"
import upArrow from "../../assets/icons/chevron-up.svg";
import downArrow from "../../assets/icons/chevron-down.svg";

const TableHeadClient = (): React.ReactElement => {
    return (
        <THead layout>
                <Tr>
                    <ThFilterable>
                        <Container>ID</Container>
                        <BoxFilterableCol style={{ marginLeft: 3, lineHeight: 0.7 }}>
                            <img src={upArrow} alt="seta para cima" />
                            <BreakLine />
                            <img src={downArrow} alt="seta para baixo" />
                        </BoxFilterableCol>
                    </ThFilterable>
                    <Th>Primeiro Nome</Th>
                    <Th>Último Nome</Th>
                    <ThFilterable>
                        <Container>Status</Container>
                        <BoxFilterableCol style={{ marginLeft: 3, lineHeight: 0.7 }}>
                            <img src={upArrow} alt="seta para cima" />
                            <BreakLine />
                            <img src={downArrow} alt="seta para baixo" />
                        </BoxFilterableCol>
                    </ThFilterable>
                    <Th>Cpf</Th>
                    <Th>Criado por</Th>
                    <Th>Cartão</Th>
                    <Th></Th>
                </Tr>
            </THead>
    )
}

export default TableHeadClient